<label class="switch" [formGroup]="switchForm">
  <input type="checkbox" formControlName="couponStatus">
  <span class="slider round"></span>
</label>
